import { SyncStatusView } from './models'
import { User } from '../../../../../models/User'

const SALESFORCE_RECORD_OBJECT_NAMES = ['Note', 'Event', 'Contact', 'Account', 'Case']

interface getExternalLinkParams {
  syncStatus: SyncStatusView
  currentUser: User | null
}

const objectNameMapper: { [key: string]: { [key: string]: string } } = {
  wealthbox: {
    notes: 'status_updates',
    task: 'tasks',
    contact: 'contacts',
  },
  redtail: {
    note: 'notes',
    task: 'activities',
  },
  salesforce: {
    task: 'Task',
    contact: 'Contact',
    account: 'Account',
  },
  practifi: {
    task: 'Task',
  },
  xlr8: {
    task: 'Task',
  },
  elements: {
    task: 'Task',
  },
  edge: {
    task: 'Task',
  },
}

const getCRMObjectName = (serviceId: string, objectName: string): string => {
  return objectNameMapper[serviceId]?.[objectName] ?? objectName
}

export const getExternalLink = ({ syncStatus, currentUser }: getExternalLinkParams): string => {
  const { integrations: currentUserIntegrations } = currentUser ?? {}
  const userIntegrationConfig = currentUserIntegrations?.find((i) => i.serviceId === syncStatus.serviceId)

  const crmObjectName = getCRMObjectName(syncStatus.serviceId, syncStatus.externalObjectName ?? 'note')
  switch (syncStatus.serviceId) {
    case 'wealthbox':
      if (!userIntegrationConfig?.externalAccountId) {
        return ''
      }
      return `https://app.crmworkspace.com/${userIntegrationConfig?.externalAccountId}/${crmObjectName}/${syncStatus.externalId}`
    case 'salesforce':
    case 'practifi':
    case 'xlr8':
    case 'elements':
    case 'blackdiamond':
      if (!syncStatus.baseUrl) {
        return ''
      }
      if (SALESFORCE_RECORD_OBJECT_NAMES.includes(crmObjectName)) {
        return `${syncStatus.baseUrl}/lightning/r/${crmObjectName}/${syncStatus.externalId}/view`
      }
      return `${syncStatus.baseUrl}/lightning/o/${crmObjectName}/home?recordId=${syncStatus.externalId}`
    case 'redtail':
      switch (crmObjectName) {
        case 'activities':
          return `https://crm.redtailtechnology.com/activities/${syncStatus.externalId}`
        case 'contact':
          return `https://crm.redtailtechnology.com/contacts/${syncStatus.externalContactId}`
      }
      return `https://crm.redtailtechnology.com/contacts/${syncStatus.externalContactId}/${crmObjectName}`
    case 'hubspot':
      if (!userIntegrationConfig?.externalAccountId) {
        return ''
      }
      if (syncStatus.externalId === syncStatus.externalContactId) {
        return `https://app.hubspot.com/contacts/${userIntegrationConfig?.externalAccountId}/contact/${syncStatus.externalContactId}`
      }
      return `https://app.hubspot.com/contacts/${userIntegrationConfig?.externalAccountId}/contact/${syncStatus.externalContactId}/?engagement=${syncStatus.externalId}`
    case 'dynamics':
    case 'engage':
      return ''
    case 'emoney':
      return `https://wealth.emaplan.com/ema/Advisor/Clients/${syncStatus.externalContactId}/Overview`
    //return `${syncStatus.baseUrl}/main.aspx?etn=${syncStatus.externalContactObjectType}&id=${syncStatus.contactId}`
  }
  return ''
}
